import { t } from "ttag";

import type { ObjectValue } from "@/shared/models/legacy-types";

const INJECTION_VALUE = {
  TWO_OR_LESS: "2-or-less",
  THREE_OR_MORE: "3-or-more",
} as const;

export type InjectionValue = ObjectValue<typeof INJECTION_VALUE>;

export const getRefillInjectionFormOptions = () =>
  [
    {
      disqualifier: false,
      value: INJECTION_VALUE.TWO_OR_LESS,
      label: t`2 or fewer injections left`,
    },
    {
      disqualifier: true,
      value: INJECTION_VALUE.THREE_OR_MORE,
      label: t`3 or more injections left`,
    },
  ] as const;
